import { isEmpty } from 'underscore';
import { Soundwave } from 'types';
import { VideoTemplateStateContent } from '../../types';

export function getSoundwave(
  state: VideoTemplateStateContent,
): Soundwave & { layerId: number } {
  const { soundwave, layers } = state;
  const layerIndex = layers.order.findIndex(
    id => layers.data[id].type === 'waveform',
  );

  if (!soundwave || layerIndex < 0) return undefined;

  const { original, ...restSoundwave } = soundwave;
  if (isEmpty(restSoundwave)) return undefined;

  return {
    layerId: layerIndex,
    waveColor: restSoundwave.color,
    wavePosition: {
      left: restSoundwave.left.toString(),
      top: restSoundwave.top.toString(),
    },
    waveGeneration:
      restSoundwave.fidelity === 'hi-fi' ? 'accurate' : 'amplitudeBased',
    waveType: restSoundwave.type,
    waveSize: {
      height: restSoundwave.height.toString(),
      width: restSoundwave.width.toString(),
    },
    waveformPrefId: restSoundwave.waveformPrefId,
  };
}
